import {
	Box,
	CircularProgress,
	Paper,
	Skeleton,
	Table,
	TableBody,
	TableContainer,
	Typography,
} from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSpecialSchemesRequest } from 'redux/reducers/settings/reducer';
import { getSpecialSchemes, getSpecialSchemesLoader } from 'redux/reducers/settings/selectors';
import { StyledTableCell, StyledTableRow } from 'ui/StyledTable';

const ROWS = Array.from(new Array(4));

export const SpecialSchemesRegistrationInformation: FC = () => {
	const dispatch = useDispatch();
	const registrationInformation = useSelector(getSpecialSchemes);
	const registrationInformationLoader = useSelector(getSpecialSchemesLoader);
	useEffect(() => {
		dispatch(getSpecialSchemesRequest());
	}, [dispatch]);
	return (
		<Paper
			sx={{
				margin: '20px 10px 20px 10px',
				maxWidth: 'calc(100vw - 20px)',
				overflowX: 'auto',
			}}
		>
			<Box sx={{ width: 'auto', minWidth: '650px' }}>
				<Box sx={{ borderRadius: '12px' }}>
					<Box
						sx={{
							backgroundColor: 'primary.light',
							p: 0.5,
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								p: '2px 4px',
							}}
						>
							<Typography sx={{ fontSize: '1.2rem', color: 'primary.main', fontWeight: 'bold' }}>
								Special Schemes Registration Information
							</Typography>

							<Box
								sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}
							></Box>
						</Box>
					</Box>
					{registrationInformation && (
						<TableContainer>
							<Table stickyHeader>
								{registrationInformation?.map((item) => (
									<TableBody key={`${item.scheme_number}`}>
										<StyledTableRow
											key={`${item.scheme_number}name`}
											sx={{ height: '35px !important' }}
										>
											<StyledTableCell
												align="left"
												colSpan={2}
												sx={{
													// width: '100%',
													paddingLeft: '20px!important',
													color: '#016193!important',
												}}
											>
												<Typography
													component="span"
													sx={{
														fontWeight: 'bold',
														fontSize: '1.0rem',
													}}
												>
													{item.number_type}
												</Typography>{' '}
												<Typography
													component="span"
													sx={{
														fontWeight: 'normal',
														fontSize: '0.9rem',
													}}
												>
													{item.description}
												</Typography>
											</StyledTableCell>
											{/* <StyledTableCell /> */}
										</StyledTableRow>
										<StyledTableRow
											key={`${item.number_type}registrationNumber`}
											sx={{ height: '35px !important' }}
										>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												Registration Number
											</StyledTableCell>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												{item.scheme_number}
											</StyledTableCell>
										</StyledTableRow>
										<StyledTableRow
											key={`${item.number_type}registrationCountry`}
											sx={{ height: '35px !important' }}
										>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												Registration Country
											</StyledTableCell>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												{item.country}
											</StyledTableCell>
										</StyledTableRow>
										<StyledTableRow
											key={`${item.number_type}registrationDate`}
											sx={{ height: '35px !important' }}
										>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												Registration Date
											</StyledTableCell>
											<StyledTableCell
												align="left"
												colSpan={1}
												sx={{ width: '50%', paddingLeft: '20px!important' }}
											>
												{DateTime.fromISO(item.scheme_date).toFormat('yyyy-MM-dd')}
											</StyledTableCell>
										</StyledTableRow>
									</TableBody>
								))}
							</Table>
						</TableContainer>
					)}
					{registrationInformationLoader && (
						<Box
							sx={{
								pb: '1px',
							}}
						>
							{ROWS.map(() => (
								<Skeleton
									key={nanoid()}
									variant="rectangular"
									height="35px"
									sx={{
										mb: '35px',
									}}
								/>
							))}
						</Box>
					)}
				</Box>
			</Box>
		</Paper>
	);
};
